export default defineComponent({
  inheritAttrs: false,
  setup: function setup() {}
});